<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="520px"
    :close-on-click-modal="false" append-to-body>
    <div class="batch-form">
      <span class="batch-label">{{ label }}：</span>
      <el-select v-model="value">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BatchOptionSetting',
  props: {
    title: { type: String, required: true },
    label: { type: String, required: true },
    options: { type: Array, default: () => [] }
  },
  data() {
    return {
      dialogVisible: false,
      value: 0
    }
  },
  methods: {
    // 客户、操作和捆包类型共用相同的单选下拉交互。
    open() {
      this.value = this.options[0].value
      this.dialogVisible = true
    },
    confirm() {
      this.$emit('confirm', this.value)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-form {
  display: flex;
  align-items: flex-start;
  min-height: 80px;
  padding: 10px 20px;
}

.batch-label {
  width: 100px;
  line-height: 40px;
  text-align: right;
  margin-right: 12px;
}

.el-select {
  flex: 1;
}
</style>
